module.exports = __webpack_public_path__ + "static/pid-ug-10-en-homescreen-c014f4e53c6c6db77c7322f749dc42c7.png";